<template>
  <v-dialog
    v-model="value.show"
    @input="v => v || closeAction()"
    max-width="500px"
    :persistent="true"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
          value.mode === "edit"
            ? $t("editSparePartType")
            : $t("createSparePartType")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="editCreateForm">
          <v-text-field
            name="name"
            :label="$t('name')"
            type="text"
            v-model="sparePartType.name"
            v-validate="'required|max:255'"
            :data-vv-as="$t('name')"
            :error-messages="errors.collect('name')"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          flat
          @click.native="closeAction"
          :disabled="value.formDisabled"
          >{{ $t("close") }}</v-btn
        >
        <v-btn
          color="blue darken-1"
          flat
          @click.native="saveAction"
          :disabled="value.formDisabled"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  UPDATE_SPARE_PART_TYPE,
  CREATE_SPARE_PART_TYPE,
  RESET_SPARE_PART_TYPE,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import validationErrorsMixin from "@/mixins/validationErrors.mixin";

export default {
  props: ["value"],
  data() {
    return {
      formDisabled: false
    };
  },
  computed: {
    ...mapGetters(["sparePartType"])
  },
  mixins: [validationErrorsMixin],
  methods: {
    saveAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.formDisabled = true;

          this.$store
            .dispatch(
              this.value.mode === "edit"
                ? UPDATE_SPARE_PART_TYPE
                : CREATE_SPARE_PART_TYPE,
              this.sparePartType
            )
            .then(() => {
              this.$store.dispatch(SHOW_SNACKBAR, {
                text: this.$t("savedSuccessfully", [this.$t("sparePartType")]),
                color: "success"
              });

              this.closeAction();
              this.$emit("saved");
            })
            .catch(() => {
              this.formDisabled = false;
            });
        }
      });
    },
    closeAction() {
      this.$emit("input", {
        mode: this.value.mode,
        show: false
      });
      this.formDisabled = false;
      // we need wait for animation until is finished
      setTimeout(() => {
        this.$store.dispatch(RESET_SPARE_PART_TYPE);
        this.$refs.editCreateForm.reset();
        this.$validator.reset();
      }, 100);
    }
  }
};
</script>

<style scoped></style>
